"use client";

import { createContext, useContext } from 'react';

const FontsContext = createContext();

export const FontsProvider = ({ children }) => {
  const fonts = {
    notosnas: {
      semiBold: {
        fontFamily: 'NotoSans-SemiBold',
        src: './Assets/Fonts/NotoSans-SemiBold.ttf',
        weight: '600'
      },
      italic: {
        fontFamily: 'NotoSans-Italic',
        src: './Assets/Fonts/NotoSans-Italic.ttf',
        weight: '400'
      }
    },
    jaqartall: {
      regular: {
        fontFamily: 'Jaqartall',
        src: './Assets/Fonts/Jaqartall.ttf',
        weight: '400'
      }
    }
  };

  return (
    <FontsContext.Provider value={fonts}>
      {children}
    </FontsContext.Provider>
  );
};

export const useFonts = () => {
  const context = useContext(FontsContext);
  if (!context) {
    throw new Error('useFonts must be used within a FontsProvider');
  }
  return context;
};
